import React, { type ReactNode } from "react";
import type { Option } from "src/components/Select/Select.tsx";

import { MultiplePreview } from "src/components/Select/MultiplePreview.tsx";
import { SinglePreview } from "src/components/Select/SinglePreview.tsx";
import { ButtonPreview } from "src/components/Select/ButtonPreview.tsx";

type PreviewProps<Value = unknown> = {
  disabled: boolean;
  isLoadingData: boolean;
  isLoadingSelectedOption: boolean;
  flatOptions: Option<Value>[];
  placeholder?: ReactNode;
  isMultiple: boolean;
  value: Value[] | Value | "";
  onValueChange: (value: Value[] | Value | "") => void;
  fallbackOptions: Option<NoInfer<Value>>[];
  truncateOptions?: boolean;
  isButton: boolean;
  onOpen: (state: boolean) => void;
  isOpen: boolean;
};

export const Preview = <Value = unknown,>({
  disabled,
  isLoadingData,
  isLoadingSelectedOption,
  onOpen,
  placeholder,
  flatOptions,
  value,
  isMultiple,
  onValueChange,
  fallbackOptions,
  truncateOptions,
  isButton,
  isOpen,
}: PreviewProps<Value>) => {
  if (isButton) {
    return (
      <ButtonPreview
        value={value as Value | ""}
        disabled={disabled}
        isLoadingData={isLoadingData}
        flatOptions={flatOptions}
        isLoadingSelectedOption={isLoadingSelectedOption}
        placeholder={placeholder}
        fallbackOptions={fallbackOptions}
        isOpen={isOpen}
      />
    );
  }
  if (isMultiple) {
    return (
      <MultiplePreview<Value>
        value={value as Value[] | ""}
        isOpen={isOpen}
        onValueChange={onValueChange}
        flatOptions={flatOptions}
        onOpen={onOpen}
        isLoadingData={isLoadingData}
        disabled={disabled}
        isLoadingSelectedOption={isLoadingSelectedOption}
        placeholder={placeholder}
        fallbackOptions={fallbackOptions}
        truncateOptions={truncateOptions}
      />
    );
  }
  return (
    <SinglePreview<Value>
      value={value as Value | ""}
      disabled={disabled}
      isLoadingData={isLoadingData}
      flatOptions={flatOptions}
      isLoadingSelectedOption={isLoadingSelectedOption}
      placeholder={placeholder}
      fallbackOptions={fallbackOptions}
    />
  );
};
